var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tabs",
    {
      staticClass: "sub-menu",
      staticStyle: { "margin-bottom": "15px" },
      attrs: { "slider-color": "primary", height: "64" }
    },
    [
      _vm.isExtendedAdvancesEnabled
        ? _c(
            "v-tab",
            {
              staticClass: "sub-menu-item",
              attrs: { to: "/delegation-advance" }
            },
            [
              _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                _vm._v("fa-money-bill-alt")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("delegation.menu.advance")) + " ")
            ],
            1
          )
        : _vm._e(),
      _vm.isDelegationOrderEnabled
        ? _c(
            "v-tab",
            {
              staticClass: "sub-menu-item",
              attrs: { to: "/delegation-order" }
            },
            [
              _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                _vm._v("send")
              ]),
              _vm._v(" " + _vm._s(_vm.$t("delegation.menu.order")) + " ")
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-tab",
        { staticClass: "sub-menu-item", attrs: { to: "/delegation" } },
        [
          _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
            _vm._v("assignment")
          ]),
          _vm._v(" " + _vm._s(_vm.$t("delegation.menu.settlement")) + " ")
        ],
        1
      ),
      _c(
        "v-tab",
        { staticClass: "sub-menu-item", attrs: { to: "/delegation-info" } },
        [
          _c("v-icon", { staticClass: "sub-menu-item-icon" }, [_vm._v("info")]),
          _vm._v(" " + _vm._s(_vm.$t("delegation.menu.info")) + " ")
        ],
        1
      ),
      _vm.isWnbUser
        ? _c(
            "v-tab",
            { staticClass: "sub-menu-item", attrs: { to: "/settings/users" } },
            [
              _c("v-icon", { staticClass: "sub-menu-item-icon" }, [
                _vm._v("settings")
              ]),
              _vm._v(
                " " + _vm._s(_vm.$t("delegation.menu.administration")) + " "
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }